import { LegalStatus, apiClient } from '@/api';
import { ReactNode, useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';

import { legalGateReadyState } from '@/state/project';

import DisclaimerModal from './DisclaimerModal';
import PrivacyProvider from './PrivacyProvider';

type Props = {
  children: ReactNode;
};

export default function LegalProvider({ children }: Props) {
  const [status, setStatus] = useState<LegalStatus | null>(null);
  const [unreachable, setUnreachable] = useState(false);
  const [privacyResolved, setPrivacyResolved] = useState(false);
  const setGateReady = useSetRecoilState(legalGateReadyState);

  const refresh = () => {
    apiClient
      .getLegalStatus()
      .then((s) => {
        setStatus(s);
        setUnreachable(false);
      })
      .catch(() => setUnreachable(true));
  };

  useEffect(refresh, []);

  useEffect(() => {
    setGateReady(
      unreachable ||
        (status !== null && !status.needs_reprompt && privacyResolved)
    );
  }, [unreachable, status, privacyResolved, setGateReady]);

  if (unreachable) {
    return <>{children}</>;
  }
  if (status === null) {
    return null;
  }
  return (
    <>
      {children}
      {status.needs_reprompt ? (
        <DisclaimerModal onAccepted={refresh} />
      ) : (
        <PrivacyProvider onResolved={setPrivacyResolved} />
      )}
    </>
  );
}
